export const updateProfileMixin = {
  emits: ['updateProfile'],
  methods: {
    updateProfile(obj) {
      this.$emit('updateProfile', obj);
    },
  },
};
